<template>
  <div id="financialManagement">
    <SideLeft
      :status="leftSideStatus"
      @changeStatus="changeLeftSideStatus"
      :key_type="filters.type"
      :key_hasSubBill="hasSubBill"
      :settlement_status="filters.status"
      :bill_code="filters.billCode"
      :order_code="filters.orderCode"
      :supplier_name="filters.distributorName"
      @filtrate="filtrate"
      @batchSearch="batchSearch"
    />
    <div class="br-contentpanel" :data-min="leftSideStatus">
      <Header
        :batchBool="batchBool"
        :check_items="checkNum"
        @exportBill="exportBill"
        :check_arr="checkArr"
        :key_type="filters.type"
        :key_hasSubBill="hasSubBill"
        :settlement_status="filters.status"
        :bill_code="filters.billCode"
        :order_code="filters.orderCode"
        :supplier_name="filters.distributorName"
        @clearKey="clearKey"
      />
      <router-view
        v-if="isSysRights('Bill.findBySupplier')"
        @changeChecked="changeChecked"
        :check_arr="checkArr"
        :first_loading="firstLoading"
        :items="bList"
        @openOrderList="openOrderList"
        @openExport="openExport"
        @openLog="openLog"
        @openReasonLog="openReasonLog"
        @popContact="popContact"
        @exportSubBill="exportSubBill"
        @attachment="attachment"
      ></router-view>
      <no-rights v-else></no-rights>
      <Pagination
        class="pd-x-20 pd-sm-x-30"
        v-if="!firstLoading"
        :cur="page"
        :all="totalPage"
        :path="'/financial-management/'"
        :page_size_select="pageSizeSelect"
        :rows_per_page="rowsPerPage"
        :total_count="totalCount"
        @changeRPPage="changeRPPage"
        @gotoPage="toPage"
      />
    </div>
    <ModalOrderList :bill_item="modalOrderListData" />
    <api-loading :show="loading"></api-loading>
    <modalLog :info="itemLog" :type="itemLogType"></modalLog>
    <Popover
      :id="'showSettleMethod'"
      :loading="popEditSettleMethod.loading"
      v-show="
        $store.state.popover.id == 'showSettleMethod' &&
        $store.state.popover.open
      "
      :style="{
        opacity:
          $store.state.popover.id == 'showSettleMethod' &&
          $store.state.popover.open
            ? 1
            : 0,
      }"
    >
      <template slot="body">
        <div class="pop-inner">
          <template v-if="popEditSettleMethod.item.paymentJson">
            <div class="d-flex mg-b-5 align-items-center">
              <span class="wd-120 tx-center d-block tx-12 tx-white-7"
                >{{ $t("financial.发货前支付")
                }}{{
                  popEditSettleMethod.item.paymentJson.deliverBefore
                }}%：</span
              >
              <span
                >￥{{
                  (
                    (popEditSettleMethod.item.realAmount *
                      popEditSettleMethod.item.paymentJson.deliverBefore) /
                    100
                  ).toFixed(2)
                }}</span
              >
            </div>
            <div class="d-flex mg-b-5 align-items-center">
              <span class="wd-120 tx-center d-block tx-12 tx-white-7"
                >{{ $t("financial.全部到货支付")
                }}{{
                  popEditSettleMethod.item.paymentJson.allReceived
                }}%：</span
              >
              <span
                >￥{{
                  (
                    (popEditSettleMethod.item.realAmount *
                      popEditSettleMethod.item.paymentJson.allReceived) /
                    100
                  ).toFixed(2)
                }}</span
              >
            </div>
            <div class="d-flex mg-b-5 align-items-center">
              <span class="wd-120 tx-center d-block tx-12 tx-white-7">{{
                $t("financial.全部到货后")
              }}</span>
              <span>{{
                popEditSettleMethod.item.paymentJson.days
                  ? popEditSettleMethod.item.paymentJson.days
                  : "0"
              }}</span>
              <span class="mg-r-5 tx-12 tx-white-7"
                >{{ $t("financial.天后支付")
                }}{{
                  popEditSettleMethod.item.paymentJson.receivedAfter
                }}%：</span
              >
              <span
                >￥{{
                  (
                    (popEditSettleMethod.item.realAmount *
                      popEditSettleMethod.item.paymentJson.receivedAfter) /
                    100
                  ).toFixed(2)
                }}</span
              >
            </div>
          </template>
        </div>
      </template>
    </Popover>
    <batch-search-dialog @handleBatchSearch="handleBatchSearch" :dialog="batchSearchDialog" v-if="batchSearchDialog.visible == true"></batch-search-dialog>
    <attachment-dialog :dialog="attachmentDialog" v-if="attachmentDialog.visible"></attachment-dialog>
  </div>
</template>

<script>
import SideLeft from "./left-side.vue"; //左边栏
import Header from "./header.vue"; //页面头部
import { pagination } from "@components/pagination.js"; //分页
import ModalOrderList from "./modal-bill-order-list.vue"; //结算订单列表
import modalLog from "./modal-log.vue";
import Popover from "@components/Popover.vue";
import BatchSearchDialog from '../../distributor/batch-search-dialog.vue'
import AttachmentDialog from './attachment-dialog.vue'

export default {
  components: {
    AttachmentDialog,
    BatchSearchDialog,
    SideLeft,
    Header,
    Pagination: pagination,
    ModalOrderList,
    modalLog,
    Popover,
  },
  data() {
    return {
      batchSearchDialog:{
        visible: false,
        key: '',
      },
      batchSearchParams: {},
      batchBool: false,
      firstLoading: false,
      loading: true,
      leftSideStatus: store.get("leftSideStatus"), //左边栏状态
      pageSizeSelect: [10, 20, 50],
      page: this.$route.params.page ? this.$route.params.page : 1,
      rowsPerPage: parseInt(store.get("s-bill-rowsPerPage"))
        ? parseInt(store.get("s-bill-rowsPerPage"))
        : 10,
      totalPage: 0,
      totalCount: 0,
      bList: [],
      filters: {
        distributorId: "",
        distributorName: "",
        status: this.$route.query.status ? this.$route.query.status : "",
        orderCode: "",
        billCode: "",
        type: "",
      },
      hasSubBill: "",
      modalOrderListData: {},
      modalSettledData: {},
      exportBillId: "",
      modalCancelData: {},
      checkArr: [],
      checkArrItems: [],
      checkNum: 0,
      checkItemsNum: [],
      itemLog: "",
      itemLogType: "",
      popEditSettleMethod: {
        loading: false,
        item: "",
      },
      popEditSettleMethodDefault: "",
      attachmentDialog: {
        visible: false,
        row: {}
      }
    };
  },
  mounted() {
    //展开折叠搜索
    let user = store.get("userInfo");
    let that = this;
    if (this.$parent.sideTop) {
      if ($(".br-subleft").outerHeight() > 56) {
        $(".br-subleft").addClass("left-more ht-54 ht-auto");
        $(".br-subleft").append(
          `<a href="javascript:;" class="d-flex align-items-center more-btn"><span class=" mg-r-5 tx-info">${this.$t(
            "app.更多"
          )}</span><i aria-hidden="true" class="tx-info fa fa-angle-down"></i></a>`
        );
        $(".more-btn").on("click", function () {
          if ($(this).find("i").hasClass("fa-angle-down")) {
            $(this).find("span").text(that.$t("app.隐藏"));
            $(this).parent(".br-subleft").removeClass("ht-54");
            $(this)
              .find("i")
              .removeClass("fa-angle-down")
              .addClass("fa-angle-up");
          } else {
            $(this).find("span").text(that.$t("app.更多"));
            $(this).parent(".br-subleft").addClass("ht-54");
            $(this)
              .find("i")
              .addClass("fa-angle-down")
              .removeClass("fa-angle-up");
          }
          let bodyH = parseInt($(window).height());
          if (user.source == 9) {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 340 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 340 + "px");
            }
          } else {
            if ($("body").hasClass("side-top")) {
              let ht = $(".br-subleft").outerHeight();
              $(".body-wrap").css("height", bodyH - 260 - ht + "px");
            } else {
              $(".body-wrap").css("height", bodyH - 260 + "px");
            }
          }
        });
      }
    }
    this.totalPage = 0;
    this.getBill();
    this.popEditSettleMethodDefault = JSON.stringify(this.popEditSettleMethod);
  },
  watch: {
    $route: "gotoPage",
    rowsPerPage: function () {
      store.set("s-bill-rowsPerPage", this.rowsPerPage);
    },
    totalPage() {
      this.checkArrItems = [];
      this.checkArr = [];
      if (this.totalPage == 0) return;
      for (var i = 0; i < this.totalPage; i++) {
        this.checkArrItems.push({
          page: 1,
          data: [],
        });
      }
    },
    page() {
      if (
        !this.checkArrItems.length ||
        !this.checkArrItems[this.page - 1] ||
        !this.checkArrItems[this.page - 1].data.length
      )
        return;
      this.checkArrItems[this.page - 1].data.forEach((item) => {
        this.checkArr.push(item.id);
      });
      this.checkItems(this.checkArrItems);
    },
    checkArrItems() {
      this.checkItems(this.checkArrItems);
    },
  },
  methods: {
    attachment(item){
      this.attachmentDialog = {
        visible: true,
        row: item
      }
    },
    batchSearch(key){
      this.batchSearchDialog = {
        visible: true,
        key: key
      }
    },
    popContact(event, item, id, position) {
      if (event.type == "mouseenter") {
        //打开
        this.$store.commit("setPopover", {
          id,
          event,
        });
        switch (id) {
          case "showSettleMethod":
            this.popEditSettleMethod = JSON.parse(
              this.popEditSettleMethodDefault
            );
            this.popEditSettleMethod.item = item;
            break;
        }
      } else {
        this.$store.commit("setPopover", { event });
      }
    },
    /**
     * 导出选择的子对账单
     */
    exportSubBill(item) {
      if ($("#ifilePro").length == 0) {
        $("body").append(
          '<iframe id="ifilePro" style="display:none"></iframe>'
        );
      }
      let openDownload = (url) => {
        document.getElementById("ifilePro").src = url;
      };
      this.loading = true;
      $.api_call(
        "api.SubBill.exportSubBill",
        {
          subBillIdList: item.checkArr.join(","),
        },
        (r) => {
          this.loading = false;
          if (r.ErrorCode == "9999") {
            openDownload(r.Data.Results.url);
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
    openReasonLog(item) {
      this.itemLogType = 1;
      this.itemLog = item;
      $("#modalLog").modal("show");
    },
    openLog(item) {
      this.itemLogType = 2;
      this.itemLog = item;
      $("#modalLog").modal("show");
    },
    exportBill(type, flag) {
      let vm = this;
      let params = {};
      let url;
      if ($("#ifilePro").length == 0) {
        $("body").append(
          '<iframe id="ifilePro" style="display:none"></iframe>'
        );
      }
      let openDownload = (url) => {
        document.getElementById("ifilePro").src = url;
      };
      if (type == 1) {
        let arr = [];
        if (this.checkItemsNum.length > 0) {
          this.checkItemsNum.forEach((item) => {
            arr.push(item.id);
          });
        }
        if (arr.length > 0) {
          params.billIds = arr.join(",");
        } else {
          ShowTip(this.$t("financial.请选择要导出的对账单"), "danger");
          return;
        }
      } else {
        if (!flag) {
          ShowTip(this.$t("financial.请选择要导出的对账单"), "danger");
          return;
        }
        if (this.totalCount > 100) {
          ShowTip(this.$t("financial.导出的对账单最多不能超过100条"), "danger");
          return;
        }
        params.distributorId = this.filters.distributorId;
        params.status = this.filters.status;
        params.orderCode = this.filters.orderCode;
        params.code = this.filters.billCode;
        params.condExport = true;
        params.billType = this.filters.type;
      }
      this.loading = true;
      $.api_call("api.Bill.exportBySupplier", params, (r) => {
        vm.loading = false;
        if (r.ErrorCode == "9999") {
          if (r.Data.Results.addTask) {
            this.$store.commit("addTaskTimeFn", moment().unix());
            return;
          }
          url = r.Data.Results.url;
          openDownload(url);
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(vm);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    changeChecked(data) {
      this.checkArr = data;
      if (!this.checkArrItems.length || !this.checkArrItems[this.page - 1])
        return;
      this.checkArrItems[this.page - 1].data = [];
      this.checkItems(this.checkArrItems);
      if (!this.checkArr.length) return;
      this.bList.forEach((item) => {
        if (
          this.checkArr.some((check) => {
            return item.id == check;
          })
        ) {
          this.checkArrItems[this.page - 1].data.push(item);
        }
      });
      this.checkItems(this.checkArrItems);
    },
    checkItems(items) {
      this.checkNum = 0;
      this.checkItemsNum = [];
      if (items.length) {
        items.forEach((item) => {
          this.checkNum += item.data.length;
          if (item.data.length) {
            item.data.forEach((data) => {
              this.checkItemsNum.push(data);
            });
          }
        });
      }
    },
    changeLeftSideStatus() {
      //改变左边栏状态
      this.leftSideStatus = !this.leftSideStatus;
      store.set("leftSideStatus", this.leftSideStatus);
    },
    handleBatchSearch(item){
      this.batchSearchParams = item
      this.batchBool = true
      this.page = 1
      this.rowsPerPage = 10
      this.getBill()
    },

    getBill(batch) {
      if (!this.isSysRights("Bill.findBySupplier")) return;
      if(batch == 'common') {
        this.batchBool = false
      }
      this.loading = true;
      let vm = this;
      let params = {
        page: this.page,
        rowsPerPage: this.rowsPerPage,
        distributorId: this.filters.distributorId,
        status: this.filters.status,
        orderCode: this.filters.orderCode,
        code: this.filters.billCode,
        billType: this.filters.type,
        hasSubBill: this.hasSubBill,
      };
      let getData = (data) => {
        this.totalPage = data.Pagination.totalPage;
        this.totalCount = data.Pagination.totalCount;
        this.bList = data.Results;
        this.bList.forEach((e) => {
          this.$set(e, "checkArr", []);
        });
        $("html,body").scrollTop(0);
        if (!this.checkArrItems.length || !this.checkArrItems[this.page - 1])
          return;
        this.checkArrItems[this.page - 1].data = [];
        this.checkItems(this.checkArrItems);
        if (!this.checkArr.length) return;
        this.bList.forEach((item) => {
          if (
            this.checkArr.some((check) => {
              return item.id == check;
            })
          ) {
            this.checkArrItems[this.page - 1].data.push(item);
          }
        });
        this.checkItems(this.checkArrItems);
      };
      if(Object.keys(this.batchSearchParams).length !== 0 && this.batchBool){
        params = {
          batchSearch: this.batchSearchParams,
          page: this.page,
          rowsPerPage: this.rowsPerPage,
        }
      }
      $.api_call("api.Bill.findBySupplier", params, function (r) {
        vm.loading = false;
        vm.firstLoading = false;
        if (r.ErrorCode == "9999") {
          if(Object.keys(vm.batchSearchParams).length !== 0){
              vm.batchSearchDialog.visible = false
            }
          getData(r.Data);
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(vm);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
    changeRPPage(num) {
      let page = this.page;
      this.rowsPerPage = num;
      this.page = 1;
      this.$router.push({ path: "/financial-management/" + 1 });
      if (page == 1) {
        this.getBill();
      }
      this.checkArr = [];
    },
    toPage(num) {
      let page = this.page;
      this.$router.replace({ path: "/financial-management/" + num });
      if (page == num) {
        this.getBill('common');
      }
      this.checkArr = [];
    },
    gotoPage() {
      this.page = this.$route.params.page ? this.$route.params.page : 1;
      this.getBill();
      this.checkArr = [];
    },
    filtrate(code, status, name, id, billCode, type, hasSubBill) {
      this.filters.orderCode = code;
      this.filters.status = status;
      this.filters.distributorName = name;
      this.filters.distributorId = id;
      this.filters.billCode = billCode;
      this.filters.type = type;
      this.hasSubBill = hasSubBill;
      //筛选都回第一页
      this.toPage(1);
    },
    clearKey(type) {
      switch (type) {
        case "hasSubBill":
          this.hasSubBill = "";
          break;
        case "batchBool":
          this.getBill('common');
          break;
        case "type":
          this.filters.type = "";
          break;
        case "code":
          this.filters.orderCode = "";
          break;
        case "status":
          this.filters.status = "";
          break;
        case "name":
          this.filters.distributorName = this.filters.distributorId = "";
          break;
        case "billCode":
          this.filters.billCode = "";
          break;
      }
      this.toPage(1);
    },
    openOrderList(obj) {
      if (!obj.id) return;
      if (!this.isSysRights("Bill.findOrderByBillIdBySupplier")) {
        ShowTip(this.$t("financial.您没有权限"), "danger");
        return false;
      }
      this.modalOrderListData = obj;
      $("#modalBillOrderList").modal("show");
    },
    openExport(billId) {
      if (!billId) return;
      let vm = this;
      this.loading = true;
      let url;
      if ($("#ifile").length == 0) {
        $("body").append('<iframe id="ifile" style="display:none"></iframe>');
      }
      let openDownload = (url) => {
        document.getElementById("ifile").src = url;
      };
      $.api_call("api.Bill.exportBySupplier", { billId }, (r) => {
        vm.loading = false;
        if (r.ErrorCode == "9999") {
          if (r.Data.Results.addTask) {
            this.$store.commit("addTaskTimeFn", moment().unix());
            return;
          }
          url = r.Data.Results.url;
          openDownload(url);
        } else {
          if (r.ErrorCode == "1002") {
            userFailure(vm);
          } else {
            ShowTip(r.Message, "danger");
          }
        }
      });
    },
  },
};
</script>